const {
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_FAIL,
  PROMOTION_ITEMS_FAIL,
  PROMOTION_ITEMS_REQUEST,
  PROMOTION_ITEMS_SUCCESS,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_DETAILS_FAIL,
} = require("../constants/productConstants");

// eslint-disable-next-line import/prefer-default-export
export const productListReducer = (
  state = { loading: true, products: [] },
  action
) => {
  switch (action.type) {
    case PRODUCT_LIST_REQUEST:
      return { loading: true };
    case PRODUCT_LIST_SUCCESS:
      return {
        loading: false,
        products: action.payload,
      };
    case PRODUCT_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const getPromotionItemsReducer = (
  state = { loading: true, products: [] },
  action
) => {
  switch (action.type) {
    case PROMOTION_ITEMS_REQUEST:
      return { loading: true, products: [] }; // Ensure products is reset during loading
    case PROMOTION_ITEMS_SUCCESS:
      return {
        loading: false,
        products: action.payload, // Directly assign action.payload (result array)
      };
    case PROMOTION_ITEMS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productDetailReducer = (
  state = { product: {}, loading: true },
  action
) => {
  switch (action.type) {
    case PRODUCT_DETAILS_REQUEST:
      return { loading: true };
    case PRODUCT_DETAILS_SUCCESS:
      console.log("Action payload:", action.payload);
      return {
        loading: false,
        product: action.payload,
      };
    case PRODUCT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
